/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Card,
  CardBody,
  Container,
  HStack,
  Heading,
  IconButton,
  Text,
} from '@mybridge/ui';
import React, { useEffect } from 'react';
import Head from 'next/head';
import { useDispatch, useSelector } from 'react-redux';
import { getStaticPageContent } from 'v4/store/actions/global.data.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { BackArrow, BackArrowRTL, MyBridgeLogoIcon } from '@mybridge/icons';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { useRouter } from 'next/router';
const AbuotPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction = useDirection();
  const router = useRouter();
  const { pageContetStatic } = useSelector((state) => state.globalData);
  useEffect(() => {
    dispatch(getStaticPageContent('about-us'));
  }, []);

  return (
    <>
      <Head>
        <title>{t('otherModules.about_us') || "About us"} - mybridge</title>
        <meta
          name="description"
          content="myBridge.me is a professional Social networking site for professionals of various backgrounds. myBridge was created exclusively for business professionals like you to bridge the gap between where you are in your career and where you want to go."
        />
        <meta
          name="keywords"
          content="Professional networking platform , Video chat & Livestream, Create and organize team, Keep your team connected, Free job search sites,  USA, Usa job sites, Job search engines, Online calendar for your business, Event listing websites, FREE USA Online Chat"
        />
      </Head>
     
      <Container maxW="1366px" className="static-page-container">
        <Card className="static-page-body" boxShadow="none">
          <CardBody>
            <HStack mb={5}>
              <IconButton size="sm" variant="transparent" onClick={() => router.back()} icon={direction === 'rtl' ? <BackArrowRTL/> : <BackArrow />} />
              {/* {t('otherModules.about_us') || "About us"} */}
              <MyBridgeLogoIcon color="#3D5A80" />
            </HStack>
            <Box
            className="static-page-body"
              dangerouslySetInnerHTML={{
                __html: pageContetStatic?.content,
              }}
            ></Box>
            {/* 
          <Heading
            as="h2"
            fontSize="18px"
            fontWeight="600"
            color="#3D5A80"
            mb={3}
          >
            About Us
          </Heading>
          <Text>
            Our mission is simple: to <b>connect</b> professionals of various
            backgrounds with ideas, unlimited opportunities, and possibilities;
            to help them <b>develop</b> through different stages of their
            careers and <b>grow</b> into productive and successful
            professionals.
          </Text>

          <Heading
            as="h5"
            fontSize="18px"
            fontWeight="600"
            color="#3D5A80"
            mb={3}
            mt={5}
          >
            About You
          </Heading>
          <Text>
            As a busy working professional, you need efficient systems to make
            your workday run smoothly. Whether you work at home or in an office,
            collaboration and networking are a part of your day-to-day
            activities and you should not settle for non-intuitive, inefficient
            platforms that can’t help you perform at your best. myBridge was
            created exclusively for business professionals like you to bridge
            the gap between where you are in your career and where you want to
            go.
          </Text>

          <Heading
            as="h5"
            fontSize="18px"
            fontWeight="600"
            color="#3D5A80"
            mb={3}
            mt={5}
          >
            About the Platform
          </Heading>
          <Text>
            With unprecedented opportunities for professional development and
            career growth through business insights, job listings, networking,
            and mentoring opportunities, you will never need to log off and take
            your conversations elsewhere.
          </Text>
          <Text>
            We have designed an innovative dashboard to chat and message through
            text and audio/visual capabilities. You can create virtual
            communities with close friends and those you would like to know
            better. Share and store photos and files; schedule meetings, and
            share your thoughts, knowledge, and opinions in your personalized
            feed to be truly collaborative with your community.
          </Text>
          <Text>
            We foster a community of forward thinkers where ideas are shared and
            brought to life in a space that does not tolerate bigotry or hatred
            against any person or group of people based on their race, religion,
            ethnicity, sex, gender identity, sexual preference, disability, or
            impairment.
          </Text>
          <Text>Elevate your career by creating a myProfile today.</Text> */}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default AbuotPage;
